import { SVGProps } from 'react';

export const VendorEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69221 7.82877L5.61549 6.45519C5.56703 6.34257 5.53888 6.21934 5.53888 6.08872L5.53842 6.08826V5.62671H0.922909C0.833368 5.62671 0.748443 5.64379 0.666748 5.66779L3.69221 7.82877Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4294 7.01152L3.96057 8.77187C3.88026 8.82911 3.7861 8.85772 3.69241 8.85772C3.59825 8.85772 3.50455 8.82911 3.42424 8.77187L0.0249237 6.34412C0.00969256 6.41058 0 6.47889 0 6.54997V10.2424C0 10.7515 0.414011 11.1655 0.923101 11.1655H6.46171C6.9708 11.1655 7.38481 10.7515 7.38481 10.2424V7.01152H6.4294Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.23087 3.02297L11.6942 1.90334L9.34331 0.85848C9.27158 0.826633 9.19017 0.826633 9.11844 0.85848L6.76758 1.90334L9.23087 3.02297Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9538 3.50524L6.46143 2.37231V4.98848C6.46143 5.09814 6.52595 5.19728 6.62592 5.24187L8.9538 6.27648V3.50524Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50757 3.50524V6.27648L11.8354 5.24187C11.9354 5.19728 11.9999 5.09814 11.9999 4.98848V2.37231L9.50757 3.50524Z"
      fill="currentColor"
    />
  </svg>
);
